import { useNavigate, Link } from "react-router-dom";

interface SiteFooterProps {
  onFeaturesClick?: () => void;
  onPricingClick?: () => void;
}

export function SiteFooter({ onFeaturesClick, onPricingClick }: SiteFooterProps) {
  const navigate = useNavigate();

  const handleFeatures = () => {
    if (onFeaturesClick) onFeaturesClick();
    else navigate("/#features");
  };
  const handlePricing = () => {
    if (onPricingClick) onPricingClick();
    else navigate("/#pricing");
  };

  return (
    <footer className="border-t border-border bg-card/30">
      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <img
                src="/splitsy-logo.png"
                alt="Splitsy logo"
                width={86}
                height={22}
                loading="lazy"
                decoding="async"
                className="h-6 w-auto"
              />
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed">Split expenses, not friendships</p>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-foreground mb-3">Product</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <button onClick={handleFeatures} className="text-muted-foreground hover:text-foreground">
                  Features
                </button>
              </li>
              <li>
                <button onClick={handlePricing} className="text-muted-foreground hover:text-foreground">
                  Pricing
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate("/auth?mode=signup")}
                  className="text-muted-foreground hover:text-foreground"
                >
                  Get Started
                </button>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-foreground mb-3">Legal</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/privacy" className="text-muted-foreground hover:text-foreground">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-muted-foreground hover:text-foreground">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/cookies" className="text-muted-foreground hover:text-foreground">
                  Cookie Policy
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-foreground mb-3">Contact</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="mailto:support@splitsy.app" className="text-muted-foreground hover:text-foreground">
                  support@splitsy.app
                </a>
              </li>
              <li>
                <a href="mailto:privacy@splitsy.app" className="text-muted-foreground hover:text-foreground">
                  privacy@splitsy.app
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-border pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-sm text-muted-foreground">© {new Date().getFullYear()} Splitsy. All rights reserved.</p>
          <div className="flex items-center gap-4 text-sm text-muted-foreground">
            <Link to="/privacy" className="hover:text-foreground">
              Privacy
            </Link>
            <Link to="/terms" className="hover:text-foreground">
              Terms
            </Link>
            <Link to="/cookies" className="hover:text-foreground">
              Cookies
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
